import { useStore } from "../stores"
import userAxios from "./axios"

export async function loadOwnerData(){
	const store = useStore()

	if(store.owner.id){
		const response = await userAxios.get('/api/user-side/getOwner/' + store.owner.id)

		// Augment owner data in the store
		store.owner = {
			id: store.owner.id,
			imageId: `/image/i.${response.data.owner_image_id}/w.800:h.800:f.0/image.png`,
			name: response.data.owner_name
		}
	}
}